import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryBillPaymentList(data) {
  return request({
    url: URL.act.billPayment.queryBillPaymentList,
    method: 'post',
    data
  })
}

export function queryBillPaymentByJobList(data) {
  return request({
    url: URL.act.billPayment.queryBillPaymentByJobList,
    method: 'post',
    data
  })
}

export function queryBillPaymentDetail(data) {
  return request({
    url: URL.act.billPayment.queryBillPaymentDetail,
    method: 'GET',
    params: data
  })
}

export function queryBillPaymentApproveHistory(data) {
  return request({
    url: URL.act.billPayment.queryBillPaymentApproveHistory,
    method: 'GET',
    params: data
  })
}

export function createBillPayment(data) {
  return request({
    url: URL.act.billPayment.createBillPayment,
    method: 'POST',
    data
  })
}

export function queryJobPageableFast(requestBody) {
  return request({
    url: URL.act.billPayment.queryJobPageableFast,
    method: 'post',
    data: requestBody
  })
}

export function queryJobPageableFastForPayApply(requestBody) {
  return request({
    url: URL.act.billPayment.queryJobPageableFastForPayApply,
    method: 'post',
    data: requestBody
  })
}

export function updateBillPayment(data) {
  return request({
    url: URL.act.billPayment.updateBillPayment,
    method: 'POST',
    data: data
  })
}
export function batchUpdateBilPaymentState(data) {
  return request({
    url: URL.act.billPayment.batchUpdateBilPaymentState,
    method: 'POST',
    data: data
  })
}

export function batchUpdateBilPaymentStatePrintMsg(data) {
  return request({
    url: URL.act.billPayment.batchUpdateBilPaymentStatePrintMsg,
    method: 'POST',
    data: data
  })
}

export function uploadFileToWeaver(data) {
  return request({
    url: URL.act.billPayment.uploadFileToWeaver,
    method: 'POST',
    data: data
  })
}

export function deleteFileToWeaver(data) {
  return request({
    url: URL.act.billPayment.deleteFileToWeaver,
    method: 'POST',
    data: data
  })
}
export function batchDelBillPayment(data, location) {
  return request({
    url: URL.act.billPayment.batchDelBillPayment,
    method: 'DELETE',
    data: data,
    params: { location }
  })
}
export function getBillPaymentTreeForInvoice(data) {
  return request({
    url: URL.act.billPayment.getBillPaymentTreeForInvoice,
    method: 'POST',
    data: data
  })
}

export function updateBillPaymentState(data) {
  return request({
    url: URL.act.billPayment.updateBillPaymentState,
    method: 'POST',
    data
  })
}

export function queryChargeOfBillPayment(data) {
  return request({
    url: URL.act.billPayment.queryChargeOfBillPayment,
    method: 'post',
    data
  })
}

export function queryJobOfBillPayment(data) {
  return request({
    url: URL.act.billPayment.queryJobOfBillPaymentUrl,
    method: 'post',
    data
  })
}

/* 发送云平台 */
export function SendWeaver(data) {
  return request({
    url: URL.act.billPayment.SendWeaver,
    method: 'POST',
    data: data
  })
}

/* Jinchang 发送云平台 */
export function SendWeaverJinchang(data) {
  return request({
    url: URL.act.billPayment.SendWeaverJinchang,
    method: 'GET',
    params: data
  })
}
// 发送Lts
export function sendLtsBillPaymentFunc(data) {
  return request({
    url: URL.act.billPayment.sendLtsBillPaymentUrl,
    method: 'POST',
    data
  })
}
// 修改付款期限
export function changePaymentList(data) {
  return request({
    url: URL.act.billPayment.changeBillPaymentList,
    method: 'post',
    data
  })
}

// 更新付款申请（审批流【同意】逻辑调用）
export function updateBillPaymentForWorkflow(data) {
  return request({
    url: URL.act.billPayment.updateBillPaymentForWorkflow,
    method: 'POST',
    data: data
  })
}

export function batchCancelBillPaymentFunc(data) {
  return request({
    url: URL.act.billPayment.batchCancelBillPaymentUrl,
    method: 'POST',
    data
  })
}

export function getChargeBillingMultiCurrencyInfo(data) {
  return request({
    url: URL.act.billPayment.getChargeBillingMultiCurrencyInfo,
    method: 'POST',
    data
  })
}

export function uploadHasPrint(data) {
  return request({
    url: URL.act.billPayment.uploadHasPrint,
    method: 'POST',
    data: data
  })
}

export function checkBillPaymentJobSettleFunc(params) {
  return request({
    url: URL.act.billPayment.checkBillPaymentJobSettleUrl,
    method: 'GET',
    params: params
  })
}

export function initiateSpecialApprovalFunc(data) {
  return request({
    url: URL.act.billPayment.initiateSpecialApprovalUrl,
    method: 'POST',
    data: data
  })
}

export function checkLackInvoiceFlagFunc(data) {
  return request({
    url: URL.act.billPayment.checkLackInvoiceFlagUrl,
    method: 'POST',
    data
  })
}

// REQ-0033：按付款类型+公司取后端清洗后的企微表单字段配置（type/companyCode 显式入参）
export function getBillPaymentWechatFormConfig(params) {
  return request({
    url: URL.act.billPayment.wechatFormConfig,
    method: 'get',
    params,
    // 返回完整错误，便于前端定位问题
    fullError: true
  })
}
